import React, { useEffect, useState } from 'react';
import { Form, Typography, Row } from 'antd';
import LoadingButton from '@mui/lab/LoadingButton';
import GenericModal from '../../../components/buttons/genericModal';
import { Box, Grid } from '@mui/material';
import LinkPlaid from '../../buttons/linkplaid';
import { backendGetRequest, backendPostWithoutRefresh } from "../../../helpers/callBackend";

const { Text } = Typography;

const ConnectMoreAccounts = (props) => {
    const [submittingFinicityConnect, setSubmittingFinicityConnect] = useState({});
    const [submittingAddFinicityGroup, setSubmittingAddFinicityGroup] = useState(false);
    const [loadingFinicityCustomers, setLoadingFinicityCustomers] = useState(true);
    const [finicityCustomers, setFinicityCustomers] = useState([]);

    useEffect(() => {
        if (props.source === undefined || props.source === 'FI') {
            backendGetRequest(
                "/api/finicity/get-connect-link/",
                { params: { many: true }},
            ).then((response) => {
                if (response?.status === 200) {
                    setFinicityCustomers(response?.data?.data);
                    setLoadingFinicityCustomers(false);
                } else {
                    // setErrorMessage(response.data.description);
                }
            });
        }
    }, [props.source]);

    const handleAddGroup = () => {
        setSubmittingAddFinicityGroup(true);
        backendPostWithoutRefresh(
            "/api/finicity/customer/",
            { link: true },
        ).then((response) => {
            if (response.status === 200) {
                setFinicityCustomers(prevState => [...prevState, response?.data?.data]);
            }
            setSubmittingAddFinicityGroup(false);
        })
    };

    return (
        <GenericModal
            size='md'
            visible={props.visible}
            handleCancelModal={() => props.handleCancelModal()}
            showModal={() => props.handleShowModal()}
            modalTitle="Connect More Accounts"
            modalBody={
                <Form layout="vertical" name="basic" autoComplete="off">
                    <Row>
                        <Text>
                            For API connections, please use Plaid or Finicity. Please discuss with your Arpari account manager whether you need to create additional Finicity groups or SFTP connections.
                        </Text>
                    </Row>
                    <Box sx={{ marginTop: 2 }}>
                        <Grid container spacing={2}>
                            {(props.source === undefined || props.source === 'PL') &&
                                <Grid item xs={12} sm={4}>
                                    <LinkPlaid
                                        buttonType={true}
                                        buttonStyle={{ height: '80px' }}
                                        buttonText="Connect With Plaid"
                                        linkCustomizationName="default"
                                        storePlaidItems={1}
                                        plaidItemId={props.sourceGroupId}
                                        accessTokenOnSuccess={props.plaidAccessTokenOnSuccess}
                                    />
                                </Grid>
                            }
                            {(props.source === undefined || props.source === 'FI') &&
                                finicityCustomers?.map((customer, index) => (
                                    <Grid item xs={12} sm={4} key={index}>
                                        <LoadingButton
                                            href={customer.link}
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            disableElevation
                                            fullWidth
                                            size="small"
                                            variant="contained"
                                            color="primary"
                                            loading={submittingFinicityConnect[index + 1]}
                                            sx={{
                                                fontSize: 14,
                                                textAlign: "center",
                                                height: '80px',
                                                textTransform: 'none',
                                                '&:hover': {
                                                    color: 'white',
                                                },
                                            }}
                                        >
                                            Connect with Finicity Group {index + 1}
                                        </LoadingButton>
                                    </Grid>
                                ))
                            }
                            {(props.source === undefined || props.source === 'FI') && 
                                <Grid item xs={12} sm={4}>
                                    <LoadingButton
                                        onClick={handleAddGroup}
                                        disableElevation
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        color="primary"
                                        loadingPosition="start"
                                        loading={submittingAddFinicityGroup || loadingFinicityCustomers}
                                        sx={{ fontSize: 14, height: '80px', textTransform: 'none' }}
                                    >
                                        + Finicity Group
                                    </LoadingButton>
                                </Grid>
                            }
                        </Grid>
                    </Box>
                </Form>
            }
        />
    );
};

export default ConnectMoreAccounts;
